// Basketball dashboard — real coverage counts (get_basketball_dashboard_stats).
// Replaces the old hardcoded demo numbers. Counts only, no edge internals.
// Honest: whatever the real ingest holds; zeros are a truthful state.

import { useMemo } from "react";
import { useRpcQuery } from "../../data/useRpcQuery.ts";

export interface BballDashStats {
  upcomingGames: number;
  fixturesTracked: number;
  booksLive: number;
  pinnacleFixtures: number;
  closingLines: number;
  marketsLive: number;
}

export interface BballDashStatsState {
  loading: boolean;
  error: string | null;
  stats: BballDashStats | null;
}

const ZERO: BballDashStats = {
  upcomingGames: 0, fixturesTracked: 0, booksLive: 0, pinnacleFixtures: 0, closingLines: 0, marketsLive: 0,
};

export function useBballDashboardStats(): BballDashStatsState {
  const q = useRpcQuery<Record<string, unknown> | null>("get_basketball_dashboard_stats", { staleTime: 60_000 });
  const stats = useMemo<BballDashStats | null>(() => {
    if (q.isLoading) return null;
    const r = (q.data ?? {}) as Record<string, unknown>;
    if (q.isError) return ZERO;
    return {
      upcomingGames: Number(r.upcoming_games ?? 0),
      fixturesTracked: Number(r.fixtures_tracked ?? 0),
      booksLive: Number(r.books_live ?? 0),
      pinnacleFixtures: Number(r.pinnacle_fixtures ?? 0),
      closingLines: Number(r.closing_lines ?? 0),
      marketsLive: Number(r.markets_live ?? 0),
    };
  }, [q.data, q.isLoading, q.isError]);
  return useMemo(
    () => ({ loading: q.isLoading, error: q.error ? q.error.message : null, stats }),
    [q.isLoading, q.error, stats],
  );
}
